
import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { RestResponse } from  '../core/core/core.model'

import 'rxjs/operator/delay';
import 'rxjs/operator/mergeMap';
import 'rxjs/operator/switchMap';
import { RestService } from '../core/core/rest.service';
import { LoginModel, ResetPasswordData, ResetFormRequest, WebToken, UserForMention } from './login.model';
import { ObjectToSelect } from '../core/shared/objectToSelect.model';

@Injectable({
  providedIn: 'root'
})
export class LoginRest {    
  private loginResponse: RestResponse<string>;
  private loginModel : LoginModel;
  private GetLoggedUserNameUrl = "api/loggedusername";
  private GetLoggedUserUrl = "api/loggeduser";

  constructor(private http: RestService) { }

  public login(user: string, password: string, customer: ObjectToSelect) : Observable<WebToken>  { 

    // this.loginModel = new LoginModel();
    // this.loginModel.login = user;
    // this.loginModel.password = password;
    
    return this.http.post('api/login', {login: user, password: password, customerId: customer == null ? null : customer.id });
  };

  public logout(): Observable<string> {
    return this.http.post<string>('api/logout', {});
  }

  public changePassword(user: string, password: string, oldPassword: string) : Observable<WebToken> {
      return this.http.post('api/changepassword', {login: user, password: password, oldPassword: oldPassword});  
  }

  public getUserRole()  {
    return this.http.get<String>('api/user/role');
  } 

  public resetPassword(data: ResetPasswordData) {
    return this.http.post('api/resetpassword', data);
  }

  public sendResetFormUrl(data: ResetFormRequest) {
    return this.http.post('api/resetpassword/sendFormUrl', data);
  }

  public GetLoggedUser(): Observable<any> {
    return this.http.get(this.GetLoggedUserUrl);
  }

  public GetLoggedUserName(): Observable<any> {
    return this.http.get(this.GetLoggedUserNameUrl);
  }

  public getCustomers(username: string) {
    return this.http.get(`api/getcustomers/${username}`);
  }

  public getUsersForMention() {
    return this.http.get<UserForMention[]>('api/getusersformention');
  }
}
